import React from 'react';
import { motion } from 'framer-motion';

const IconAnalytics = (props) => (
  <motion.svg {...props} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25 75V55" stroke="currentColor" strokeWidth="5" strokeLinecap="round"/>
    <path d="M40 75V35" stroke="currentColor" strokeWidth="5" strokeLinecap="round"/>
    <path d="M55 75V60" stroke="currentColor" strokeWidth="5" strokeLinecap="round"/>
    <path d="M70 75V25" stroke="currentColor" strokeWidth="5" strokeLinecap="round"/>
    <path d="M18 78H82" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
  </motion.svg>
);

export default IconAnalytics;